import { useState } from "react";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
import Button from "../UI/Button";
import Text from "../UI/Text";
import Callout from "../UI/Callout";
// @ts-expect-error pure js
import useLoader from "../../hooks/use-loader";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import styles from "./RevokeInviteDialog.module.css";

interface RevokeInviteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Le locataire a déjà créé son compte : on révoque l'accès, pas seulement le lien. */
  isConnected: boolean;
  onRevoke: () => void | Promise<void>;
}

export default function RevokeInviteDialog({
  open,
  onOpenChange,
  isConnected,
  onRevoke,
}: RevokeInviteDialogProps) {
  const [error, setError] = useState("");
  const [isRevoking, handleRevoke] = useLoader(async () => {
    setError("");
    try {
      await onRevoke();
    } catch (err) {
      setError(handleAPIError(err));
      return;
    }
    onOpenChange(false);
  });

  function handleOpenChange(nextOpen: boolean) {
    if (!nextOpen) setError("");
    onOpenChange(nextOpen);
  }

  return (
    <ModalDialog
      open={open}
      onOpenChange={handleOpenChange}
      header={
        isConnected ? "Révoquer l'accès du locataire" : "Révoquer l'invitation"
      }
      size="sm"
    >
      <ModalDialogBody className={styles.body}>
        <Text>
          {isConnected
            ? "Le locataire n'aura plus accès à son espace pour cette location (documents partagés, quittances, historique des paiements)."
            : "Le lien d'invitation envoyé ne sera plus valable et le locataire ne pourra pas accéder à son espace."}{" "}
          Vous pourrez l'inviter à nouveau à tout moment.
        </Text>
        <Callout variant="danger">{error}</Callout>
      </ModalDialogBody>
      <ModalDialogFooter>
        <Button variant="secondary" onClick={() => handleOpenChange(false)}>
          Annuler
        </Button>
        <Button
          variant="primary"
          isLoading={isRevoking}
          onClick={() => {
            handleRevoke().catch(console.error);
          }}
        >
          Révoquer
        </Button>
      </ModalDialogFooter>
    </ModalDialog>
  );
}
